import React, { Component } from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Col } from "antd";
import CompanyInvoicesAddForm from "./company-invoices-add-form";


const MODAL_BODY_STYLE = {
    height: 500,
    justifyContent: "center",
    // alignItems: "center",
    marginTop: "1rem",
    display: "flex",
    backgroundColor: "#fafafa"
};

export default class CompanyInvoicesAddModal extends Component {
    render() {
        return (
            <div
                style={MODAL_BODY_STYLE}
            >
                <Col span={14} >
                    <div style={{ textAlign: "center" }}>
                        <h2 style={{ fontWeight: "600" }} className={"p-0 m-0"} >Submit Invoices for disbursal</h2>
                        <span style={{ fontWeight: "200" }}>Submit Invoices for disbursal</span>
                    </div>
                    <CompanyInvoicesAddForm
                        values={new Map(this.props.values)}
                        loading={this.props.loading}
                        modalSubmit={this.props.modalSubmit}
                        getDealers={this.props.getDealers}
                        dealers={this.props.dealers}
                        handleInvoiceForm={this.props.handleInvoiceForm}
                        selectedSeller={this.props.selectedSeller}
                    />
                </Col>
            </div>
        );
    }
}

CompanyInvoicesAddModal.defaultProps = {
    values: {}
};

CompanyInvoicesAddModal.propTypes = {
    visible: PropTypes.bool,
    toggleModal: PropTypes.func,
    modalSubmit: PropTypes.func,
    loading: PropTypes.bool,
    values: PropTypes.object,
    getDealers : PropTypes.func,
    dealers : PropTypes.object,
    handleInvoiceForm : PropTypes.func,
    selectedSeller : PropTypes.object
};
